import UserSessionService from "../UserSessionService";
import BasicAuthGenerator from "../../utils/BasicAuthGenerator";
import WsService from "../WsService";
import SelfToSelfLimitResult from "../../domain/Transaction/inbound/SelfToSelfLimitResult";

const ENDPOINT_BASE = "/self-to-self/limit/check";

export default class SelfToSelfLimitService {

    static checkLimits(idType, amount) {
        let endpoint = ENDPOINT_BASE + "?id-type=" + idType + "&amount=" + amount;

        let transactionHeaders = UserSessionService.retrieveTransactingHeaders();
        let registrationHeaders = UserSessionService.retrieveRegisteringAuth();
        let headers = {
            ...transactionHeaders,
            "Authorization": BasicAuthGenerator.create(registrationHeaders["registering-partner-username"], registrationHeaders["registering-partner-password"]),
        };

        return WsService.getWithHeaders(endpoint, {}, 200, headers).then(
            response => {
                return new SelfToSelfLimitResult(response);
            },
            response => {
                return response;
            });
    }
}